import superagent from 'superagent';
import * as c from '../constants/actionTypes';
import * as config from '../config/config';


export function openCitationMenu(){
  return {
    type: c.OPEN_CITATION_MENU,
    state: true
  }
}

export function closeCitationMenu(){
  return {
    type: c.CLOSE_CITATION_MENU,
    state: false
  }
}

export function openExtraModal() {
  return {
    type: c.OPEN_EXTRAS_MODAL,
    state: true
  }
}

export function openTermsModal() {
  return {
    type: c.OPEN_TERMS_MODAL,
    state: true
  }
}

export function closeTermsModal(){
  return {
    type: c.CLOSE_TERMS_MODAL,
    state: false
  }
}
export function CloseFAQModal(){
  return {
    type: c.CLOSE_FAQ_MODAL,
    state: false
  }
}
export function closeAllModals(){
  return {
    type: c.CLOSE_ALL_MODALS,
    state: false
  }
}


export function OpenFAQModal(){
  return {
    type: c.OPEN_FAQ_MODAL,
    state: true
  }
}

export function closeExtraModal() {
  return {
    type: c.CLOSE_EXTRAS_MODAL,
    state: false
  }
}

export function openBronzeExampleModal(){
  return {
    type: c.OPEN_BRONZE_EXAMPLE_MODAL,
    state: true
  }
}

export function closeBronzeExampleModal(){
  return {
    type: c.CLOSE_BRONZE_EXAMPLE_MODAL,
    state: false
  }
}

export function closeSilverExampleModal(){
  return {
    type: c.CLOSE_SILVER_EXAMPLE_MODAL,
    state: false
  }
}

export function closeGoldExampleModal(){
  return {
    type: c.CLOSE_GOLD_EXAMPLE_MODAL,
    state: false
  }
}


export function openSilverExampleModal(){
  return {
    type: c.OPEN_SILVER_EXAMPLE_MODAL,
    state: true
  }
}

export function openGoldExampleModal(){
  return {
    type: c.OPEN_GOLD_EXAMPLE_MODAL,
    state: true
  }
}



// WEBPACK FOOTER //
// ./src/actions/modals.js